import React from 'react'
import styled from 'styled-components'
import date_navchoiceStyles from './date_navchoice.styles'

const StyleWrapper = styled.div`
  ${date_navchoiceStyles}
`

const DateNavChoiceAtom = function ({...props}) {
  return <StyleWrapper>{props.children}</StyleWrapper>
}

export default DateNavChoiceAtom
